import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { client } from '@authy/lib-client/trpc'

import { appState } from '@/appState'
import { rootRoute } from '@/tenant/applications/application/root'

export const appearanceRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/appearance',
    component: lazyRouteComponent(() => import('./Appearance'), 'Appearance'),
    loader: async ({ abortController, parentMatchPromise, params: { applicationId } }) => {
        await parentMatchPromise

        const presenterSettings = await client.applications.presenter.getPresenterSettings.query(
            {
                tenantId: appState.tenant!._id.toString(),
                applicationId,
            },
            { signal: abortController.signal }
        )

        return { presenterSettings }
    },
})
